/**
 * Semantic status vocabulary from DESIGN_SPEC.md.
 *
 * Colour families follow the mapping already established by
 * `label/Label.vue` (`bg-n-{family}-3` + `text-n-{family}-11`): teal for
 * healthy, amber for attention, ruby for risk, blue for informational, slate
 * for inactive. The repo uses teal, not green.
 *
 * Colour is never the only cue - every chip renders its label as text.
 */
export const STATUS_OPTIONS = [
  'healthy',
  'connected',
  'resolved',
  'needsAttention',
  'atRisk',
  'paused',
  'scheduled',
  'processing',
  'draft',
  'unavailable',
];

export const STATUS_CONFIG = {
  healthy: {
    labelKey: 'STATUS_CHIP.HEALTHY',
    classes: 'bg-n-teal-3 text-n-teal-11',
    icon: 'i-lucide-circle-check',
  },
  connected: {
    labelKey: 'STATUS_CHIP.CONNECTED',
    classes: 'bg-n-teal-3 text-n-teal-11',
    icon: 'i-lucide-plug',
  },
  resolved: {
    labelKey: 'STATUS_CHIP.RESOLVED',
    classes: 'bg-n-teal-3 text-n-teal-11',
    icon: 'i-lucide-check',
  },
  needsAttention: {
    labelKey: 'STATUS_CHIP.NEEDS_ATTENTION',
    classes: 'bg-n-amber-3 text-n-amber-11',
    icon: 'i-lucide-triangle-alert',
  },
  atRisk: {
    labelKey: 'STATUS_CHIP.AT_RISK',
    classes: 'bg-n-ruby-3 text-n-ruby-11',
    icon: 'i-lucide-clock-alert',
  },
  paused: {
    labelKey: 'STATUS_CHIP.PAUSED',
    classes: 'bg-n-amber-3 text-n-amber-11',
    icon: 'i-lucide-pause',
  },
  scheduled: {
    labelKey: 'STATUS_CHIP.SCHEDULED',
    classes: 'bg-n-blue-3 text-n-blue-11',
    icon: 'i-lucide-calendar-clock',
  },
  processing: {
    labelKey: 'STATUS_CHIP.PROCESSING',
    classes: 'bg-n-blue-3 text-n-blue-11',
    icon: 'i-lucide-loader-circle',
    busy: true,
  },
  draft: {
    labelKey: 'STATUS_CHIP.DRAFT',
    classes: 'bg-n-slate-3 text-n-slate-11',
    icon: 'i-lucide-pencil-line',
  },
  unavailable: {
    labelKey: 'STATUS_CHIP.UNAVAILABLE',
    classes: 'bg-n-slate-3 text-n-slate-11',
    icon: 'i-lucide-ban',
    // `unavailable` must always state why - see StatusChip.vue.
    requiresReason: true,
  },
};

export const SIZE_CLASSES = {
  sm: 'h-5 px-1.5 gap-1 text-label-small',
  md: 'h-6 px-2 gap-1.5 text-label-small',
};
